export default __webpack_public_path__ + "static/media/5bet_image_2.15b38c84.png";